import { render, staticRenderFns } from "./BatchCancel.vue?vue&type=template&id=7346c56d&"
import script from "./BatchCancel.vue?vue&type=script&lang=js&"
export * from "./BatchCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7346c56d')) {
      api.createRecord('7346c56d', component.options)
    } else {
      api.reload('7346c56d', component.options)
    }
    module.hot.accept("./BatchCancel.vue?vue&type=template&id=7346c56d&", function () {
      api.rerender('7346c56d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchCancel.vue"
export default component.exports